import React from "react";
import {BsFillTelephoneFill, BsGithub, BsLinkedin} from "react-icons/bs"
import {MdEmail} from "react-icons/md"
import  Timeline from "./Timeline";
import  Introduction  from "./Introduction";
import { Type } from "./Type";
import { Techstacks } from "./Techstacks";
import "./About.css";
//aos is used for animation from left to right and so on
// target="_blank" will open the file in new tab
//aria-label is like alt

const About = () => {
  return (
    <>
      <div className="about center">
        <h1 data-aos="fade-right" className="bott">
          Hi, I am <span className="about__name">Mamata Ingole</span>
        </h1>
        {/* Typewriter */}
        <Type/>
        <p className="about__desc" data-aos="fade-right">
          I am a passionate Full Stack Web Developer who focuses on writing
          clean and user-friendly applications using JavaScript, HTML, CSS,
          React, etc. Ability to learn new technologies quickly, Capability to
          work in teams by providing Valuable Support.Looking forward to working
          on exciting projects that can help in making people's lives better and
          comfortable.
        </p>
        <div className="about_contact center">
          <a
            href="https://github.com/mamataingole125"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon "
          >
          <h2> <BsGithub /></h2>
          </a>
          <a
            href="mailto:mamataingole125@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
          <h2><MdEmail/></h2>
          </a>
          <a
            href="tel:+917385359456"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
          <h2>  <BsFillTelephoneFill/></h2>
          </a>
          <a
            href="https://www.linkedin.com/in/mamata-ingole-53b5281b2/"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
          <h2> <BsLinkedin/></h2>
          </a>
         
        </div>
      </div>

      <Introduction/>
      <section id="#skills">
        <Techstacks />
      </section>
      <Timeline/>
     
    </>
  );
};

export default About;
